import { render } from "./SupplyValidation.vue?vue&type=template&id=4b7c996f&scoped=true"
import script from "./SupplyValidation.vue?vue&type=script&lang=js"
export * from "./SupplyValidation.vue?vue&type=script&lang=js"

import "./SupplyValidation.vue?vue&type=style&index=0&id=4b7c996f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7c996f"]])

export default __exports__